
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/link/embedded-institution-search",
      function () {
        return require("private-next-pages/docs/link/embedded-institution-search.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/link/embedded-institution-search"])
      });
    }
  